import { ScreeningReportPresenceDto } from '@/app/common/general-types/social-screening.dto';

/** Trimmed executive summary, or nothing when the stored report has no written read yet. */
export function executiveSummaryFromReport(
  report: ScreeningReportPresenceDto['report'],
): string | undefined {
  const summary = report?.creatorReport?.summary?.trim() ?? '';
  return summary.length > 0 ? summary : undefined;
}
